/** How a telemetry metric value was aggregated */
export var TelemetryAggregation;
(function (TelemetryAggregation) {
    /** Count */
    TelemetryAggregation["Count"] = "C";
    /** Sum */
    TelemetryAggregation["Sum"] = "S";
    /** Average */
    TelemetryAggregation["Average"] = "A";
    /** Min */
    TelemetryAggregation["Min"] = "N";
    /** Max */
    TelemetryAggregation["Max"] = "X";
})(TelemetryAggregation || (TelemetryAggregation = {}));
